import httpServer from "../axios";
import {baseUrlx,baseUrlq} from "..";

export default {
  // 获取岗位
  getJobs(params) {
    return httpServer('post',baseUrlq + "api/student/job/enterprise/list", params);
  },
  getHotJobs(params) {
    return httpServer('get',baseUrlq + "api/student/xcx_job/top/list", {},false);
  },
  getJobDetail(id){
    return httpServer('get',baseUrlq + "api/student/xcx_job/get/"+id, {},false);
  },
  getJobPic(id){
    return httpServer('get',baseUrlq + "api/enterprise/job/pic/get/"+id, {},false);

  }
};